import { AfterViewInit, Directive, ElementRef, NgZone, OnDestroy } from '@angular/core';

// Scroll-aware edge fade for a horizontally-scrollable tab strip: fades only the
// side(s) that still have hidden tabs. Adds `js-tab-fade` to opt the strip out of
// the CSS both-edge fallback, then toggles `is-overflow-left` / `is-overflow-right`
// (read by styles.scss). Listeners run outside Angular so scrolling doesn't trigger
// change detection.
@Directive({ selector: '.nav-tabs' })
export class TabScrollFadeDirective implements AfterViewInit, OnDestroy {
  private el: HTMLElement;
  private ro?: ResizeObserver;
  private mo?: MutationObserver;
  private onScroll = () => this.update();

  constructor(elRef: ElementRef, private zone: NgZone) {
    this.el = elRef.nativeElement;
  }

  ngAfterViewInit(): void {
    this.el.classList.add('js-tab-fade');
    this.zone.runOutsideAngular(() => {
      this.el.addEventListener('scroll', this.onScroll, { passive: true });
      if (typeof ResizeObserver !== 'undefined') {
        this.ro = new ResizeObserver(() => this.update());
        this.ro.observe(this.el);
      }
      this.mo = new MutationObserver(() => this.update());
      this.mo.observe(this.el, { childList: true, subtree: true });
      this.update();
    });
  }

  ngOnDestroy(): void {
    this.el.removeEventListener('scroll', this.onScroll);
    this.ro?.disconnect();
    this.mo?.disconnect();
  }

  private update(): void {
    const el = this.el;
    el.classList.toggle('is-overflow-left', el.scrollLeft > 1);
    el.classList.toggle('is-overflow-right', el.scrollLeft < el.scrollWidth - el.clientWidth - 1);
  }
}
